import { render, staticRenderFns } from "./MatchStatistics.vue?vue&type=template&id=42bb3928&scoped=true"
import script from "./MatchStatistics.vue?vue&type=script&lang=js"
export * from "./MatchStatistics.vue?vue&type=script&lang=js"
import style0 from "./MatchStatistics.vue?vue&type=style&index=0&id=42bb3928&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "42bb3928",
  null
  
)

export default component.exports